import LandingTitle from '../LandingTitle/LandingTitle';

const MostScrappedContentsHeader = () => {
  return <LandingTitle title="많이 스크랩된 콘텐츠" />;
};

export default MostScrappedContentsHeader;
